import { render, staticRenderFns } from "./OrderSteps.vue?vue&type=template&id=5da989b2&scoped=true&"
import script from "./OrderSteps.vue?vue&type=script&lang=js&"
export * from "./OrderSteps.vue?vue&type=script&lang=js&"
import style0 from "./OrderSteps.vue?vue&type=style&index=0&id=5da989b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da989b2",
  null
  
)

export default component.exports